<template>
  <div>
    <div class="label">Ảnh hồ sơ</div>
    <div class="papers-images-section">
      <template v-for="(image, index) in uploadedImages">
        <div :key="index" class="papers-images-section__image-item">
          <template v-if="uploadedImages[index]?.url != null">
            <img
              class="papers-images-section__image"
              :src="uploadedImages[index].url"
            />
            <div
              class="papers-images-section__delete-image-item"
              @click="onDeleteImage(index, 'UPLOADED')"
            >
              <div class="trash-can-icon"></div>
            </div>
          </template>
          <template v-else-if="images[index]?.url != null">
            <img
              class="papers-images-section__image image"
              :src="images[index].url"
            />
            <div
              class="papers-images-section__delete-image-item"
              @click="onDeleteImage(index, 'FROM_RECORD')"
            >
              <div class="trash-can-icon"></div>
            </div>
          </template>
          <template v-else>
            <label :for="htmlId + '-' + index" class="">
              <div class="papers-images-section__image">
                <div class="text-sm text-gray-600">
                  <svg
                    aria-hidden="true"
                    class="mx-auto h-12 w-12 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 48 48"
                  >
                    <path
                      d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    ></path>
                  </svg>
                  <p class="papers-images-section__image__description">
                    <span class="text-primary">
                      {{
                        (index == 0 ? 'Mặt trước' : 'Mặt sau') +
                        ', định dạng PNG, JPG'
                      }}</span
                    >
                    <span class="block text-xs text-gray-500"
                      >dung lượng không quá 5MB</span
                    >
                  </p>
                </div>
              </div>
            </label>
          </template>
          <input
            :id="htmlId + '-' + index"
            :key="`image${index}-${inputKey}`"
            :ref="`inputRefs${index}`"
            accept="image/png, image/gif, image/jpeg"
            type="file"
            multiple
            @change="e => onUploadFile(e, index)"
          />
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    htmlId: {
      type: String,
      default: 'image-upload'
    },
    images: {
      type: Array,
      default: () => []
    },
    uploadedImages: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      inputKey: false,
      inputRefs: []
    }
  },
  methods: {
    removeImageFromInput(index) {
      this.inputKey = !this.inputKey
    },
    onDeleteImage(index, type) {
      this.removeImageFromInput(index)
      this.$emit('deleteImage', index, type)
    },
    onUploadFile(e, index) {
      this.$emit('uploadImage', e.target.files[0], index)
    }
  }
}
</script>
<style scoped lang="scss">
.papers-images-section {
  width: 320px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  input {
    display: none;
  }

  &__add-image-button {
    font-size: 15px;
    font-weight: 600;

    &:hover {
      cursor: pointer;
      text-decoration: underline;
      text-underline-offset: 2px;
    }
  }

  &__image-item {
    position: relative;
  }

  &__delete-image-item {
    height: 28px;
    width: 28px;
    display: block;
    position: absolute;
    top: 8px;
    right: 8px;
    background-color: rgba(211, 205, 205, 0.5);
    padding: 4px;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      background-color: rgba(211, 205, 205, 0.8);
    }
  }

  &__image {
    cursor: pointer;
    display: grid;
    align-items: center;
    border-radius: 0.5rem;
    border-width: 1px;
    border-style: solid;
    width: 100%;
    height: 12rem;
    text-align: center;
    border-color: #d1d5db;
    object-fit: contain;

    svg {
      width: 3rem;
      height: 3rem;
      color: #9ca3af;
      margin: 0 auto;
    }

    &__description {
      margin-top: 0.25rem;
      color: #6b7280;
      font-weight: 400;
      font-size: 14px;
    }
  }
}
</style>
